import React, { useRef } from "react";
import SelectInput from "../Builder/nodes/Logic/Inputs/SelectInput.tsx";

export default function CustomReportAllSelectInput({
  value = [],
  onChange,
  options = [],
  allLabel = "All",
  ...props
}) {
  const allValue = `__all_${allLabel.toLowerCase().replace(/[^a-z0-9]+/g, "_")}__`;
  const previousValues = useRef(value);
  const selectedValues = value.length ? value : [allValue];
  const allOptions = [{ value: allValue, label: allLabel }, ...options];

  return <SelectInput
    {...props}
    value={selectedValues}
    options={allOptions}
    getValueLabels={async (values) => values.map((item) =>
      allOptions.find((option) => option.value === item) || { value: item, label: item }
    )}
    onChange={(values) => {
      const selectedAll = values.includes(allValue);
      const previousHadAll = !previousValues.current.length;
      const withoutAll = values.filter((item) => item !== allValue);
      const nextValues = selectedAll && !previousHadAll ? [] : withoutAll;
      previousValues.current = nextValues;
      onChange(nextValues);
    }}
  />;
}
